import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { UncontrolledTooltip } from 'reactstrap';
import Icon from '../../../components/Icon';
import { Duration } from './Duration';
import { DiffPercentage } from './DiffPercentage';
export const MetricItem = ({ amount, diff, avgTime, type, loading = false, link }) => {
    const { t } = useTranslation();
    const itemClass = 'metrics__item metrics__item--' + type;
    const content = (_jsxs(_Fragment, { children: [!loading && _jsx("span", { className: "metrics__amount", children: amount }), _jsxs("h3", { className: "metrics__title", children: [t('prMetrics.' + type + '.title'), _jsx("span", { className: "metrics__info", id: 'type-' + type + '-icon', children: _jsx(Icon, { name: "info-circle" }) }), _jsx(UncontrolledTooltip, { target: 'type-' + type + '-icon', children: _jsx("small", { children: t('prMetrics.' + type + '.tooltip') }) })] }), !!(!loading && diff) && _jsx(DiffPercentage, { diff: diff }), _jsx(Duration, { avgTime: avgTime, type: type, loading: loading })] }));
    if (link) {
        return (_jsx(Link, { className: itemClass, to: link, children: content }));
    }
    return _jsx("div", { className: itemClass, children: content });
};
